import {View} from 'react-native'
import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {logger} from '#/logger'
import {type Shadow} from '#/state/cache/types'
import {useWsocialAccountType} from '#/state/queries/profile'
import {useSession} from '#/state/session'
import {atoms as a} from '#/alf'
import {Button} from '#/components/Button'
import {useDialogControl} from '#/components/Dialog'
import {VerifiedWSocialCheck} from '#/components/icons/VerifiedWSocialCheck'
// import {WSocialBotCheck} from '#/components/icons/WSocialBotCheck'
// import {WSocialOrgCheck} from '#/components/icons/WSocialOrgCheck'
// import {WSocialSvcCheck} from '#/components/icons/WSocialSvcCheck'
// import {WSocialTstCheck} from '#/components/icons/WSocialTstCheck'
import {VerificationsWSocialDialog} from '#/components/verification/VerificationsWSocialDialog'
import type * as bsky from '#/types/bsky'
import {type AccountType, type WsocialProfile} from '#/wsocial/types/profile'

export function WSocialVerificationCheckButton({
  profile,
  size,
}: {
  profile: Shadow<WsocialProfile>
  size: 'lg' | 'md' | 'sm'
}) {
  const accountType = useWsocialAccountType({labels: profile?.labels})

  switch (accountType) {
    case 'personal':
    case 'human': // legacy compat bridge
      return <Badge profile={profile} size={size} accountType="personal" />
    // case 'bot':
    //   return (
    //     <AccountTypeIconButton
    //       profile={profile}
    //       size={size}
    //       icon={WSocialBotCheck}
    //       accountType="bot"
    //     />
    //   )
    // case 'organization':
    //   return (
    //     <AccountTypeIconButton
    //       profile={profile}
    //       size={size}
    //       icon={WSocialOrgCheck}
    //       accountType="organization"
    //     />
    //   )
    // case 'service':
    //   return (
    //     <AccountTypeIconButton
    //       profile={profile}
    //       size={size}
    //       icon={WSocialSvcCheck}
    //       accountType="service"
    //     />
    //   )
    // case 'test':
    //   return (
    //     <AccountTypeIconButton
    //       profile={profile}
    //       size={size}
    //       icon={WSocialTstCheck}
    //       accountType="test"
    //     />
    //   )
    default:
      return null
  }
}

// -- AccountTypeIconButton (for non-personal types — disabled until design is finalised) -------
// function AccountTypeIconButton({
//   profile,
//   size,
//   icon: Icon,
//   accountType,
// }: {
//   profile: Shadow<WsocialProfile>
//   size: 'lg' | 'md' | 'sm'
//   icon: FC<{size: 'lg' | 'md' | 'sm'}>
//   accountType: AccountType
// }) {
//   const {_} = useLingui()
//   const {currentAccount} = useSession()
//   const verificationsDialogControl = useDialogControl()
//   const isViewer = profile.did === currentAccount?.did
//   const width = size === 'lg' ? 30 : 20
//   return (
//     <>
//       <Button
//         label={isViewer ? _(msg`View your verifications`) : _(msg`View this user's verifications`)}
//         hitSlop={20}
//         onPress={evt => {
//           evt.preventDefault()
//           logger.metric('verification:badge:click', {}, {statsig: true})
//           verificationsDialogControl.open()
//         }}>
//         {({hovered}) => (
//           <View style={[a.justify_center, a.align_center, a.transition_transform, {width, height: '100%', transform: [{scale: hovered ? 1.1 : 1}]}]}>
//             <Icon size={size} />
//           </View>
//         )}
//       </Button>
//       <VerificationsWSocialDialog control={verificationsDialogControl} profile={profile as bsky.profile.AnyProfileView} accountType={accountType} />
//     </>
//   )
// }

export function Badge({
  profile,
  size,
  accountType,
}: {
  profile: Shadow<WsocialProfile>
  size: 'lg' | 'md' | 'sm'
  accountType?: AccountType
}) {
  const {_} = useLingui()
  const {currentAccount} = useSession()
  const verificationsDialogControl = useDialogControl()
  const isViewer = profile.did === currentAccount?.did
  const width = size === 'lg' ? 30 : 20

  return (
    <>
      <Button
        label={
          isViewer
            ? _(msg`View your verifications`)
            : _(msg`View this user's verifications`)
        }
        hitSlop={20}
        onPress={evt => {
          evt.preventDefault()
          logger.metric('verification:badge:click', {}, {statsig: true})
          verificationsDialogControl.open()
        }}>
        {({hovered}) => (
          <View
            style={[
              a.justify_center,
              a.align_center,
              a.transition_transform,
              {
                width,
                height: '100%',
                transform: [{scale: hovered ? 1.1 : 1}],
              },
            ]}>
            <VerifiedWSocialCheck size={size} />
          </View>
        )}
      </Button>

      <VerificationsWSocialDialog
        control={verificationsDialogControl}
        profile={profile as bsky.profile.AnyProfileView}
        accountType={accountType}
      />
    </>
  )
}

export function WsocialVerificayionCheck({
  profile,
  size,
  noGap,
}: {
  profile: WsocialProfile
  size: 'lg' | 'md' | 'sm'
  noGap?: boolean
}) {
  const accountType = useWsocialAccountType({labels: profile?.labels})
  const width = size === 'lg' ? 30 : 20

  const containerStyle = [
    a.justify_center,
    a.align_center,
    noGap ? a.pl_0 : a.pl_xs,
    {width, height: '100%'} as const,
  ]

  switch (accountType) {
    case 'personal':
    case 'human': // legacy compat bridge
      return (
        <View style={[...containerStyle, a.transition_transform]}>
          <VerifiedWSocialCheck size={size} />
        </View>
      )
    // case 'bot':
    //   return <View style={containerStyle}><WSocialBotCheck size={size} /></View>
    // case 'organization':
    //   return <View style={containerStyle}><WSocialOrgCheck size={size} /></View>
    // case 'service':
    //   return <View style={containerStyle}><WSocialSvcCheck size={size} /></View>
    // case 'test':
    //   return <View style={containerStyle}><WSocialTstCheck size={size} /></View>
    default:
      return null
  }
}
